import { AfterViewInit, Component, ElementRef, Input, ViewChild } from '@angular/core';

@Component({
  selector: 'fl-loading-container',
  templateUrl: 'loading-container.component.html',
  styleUrls: ['loading-container.component.css'],
})
export class LoadingContainerComponent implements AfterViewInit {
  @Input()
  public loading = true;
  @Input()
  public width = 'auto';
  @Input()
  public height = '200px';
  @Input()
  public imageWidth = '64px';
  @Input()
  public imageHeight = '64px';
  @Input()
  public bgColor = 'transparent';
  @Input()
  public src = 'dist/assets/images/loading/hourglass.gif';
  @ViewChild('content')
  public content: any;
  @ViewChild('spinner')
  public spinner: any;

  constructor(private el: ElementRef) {}

  public ngAfterViewInit() {}
}

// import { BaseComponent } from './../../../frameworks/core/index';
// import { Input } from '@angular/core';
// @BaseComponent({
//     moduleId: module.id,
//     selector: 'loading-container',
//     templateUrl: 'loading-container.component.html',
//     styleUrls: ['loading-container.component.css']
// })
// export class LoadingContainerComponent {
//     @Input() loading: boolean;
//     @Input() width: string = 'auto';
//     @Input() height: string = '200px';
//     @Input() imageWidth: string = '64px';
//     @Input() imageHeight: string = '64px';
//     @Input() bgColor: string = 'transparent';
//     @Input() src: string = 'assets/images/loading/hourglass.gif';

// }
